import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { severitySelect } from 'Common/styles/style';
import SeverityIcon from 'Common/Components/SeverityIcon';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { selectPermissions } from 'store/Manage/selectors';
import { updateVulnGeneral } from 'store/ManageGeneral/actions';
import { capitalize } from 'utils/stringUtils';
import get from 'lodash/get';
import { severities } from 'Screens/Constants';
import { Wrapper, SeverityName } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ActionBar/components/SeverityPicker/styled';
import { selectReadOnly } from 'store/Faraday/selectors';

const SeverityItem = ({ title }) => (
  <div style={ { display: 'flex', alignItems: 'center' } }>
    <SeverityIcon type={ title.charAt(0).toUpperCase() }>{title.charAt(0).toUpperCase()}</SeverityIcon>
    <SeverityName>{ capitalize(title) }</SeverityName>
  </div>
);

const SeverityPicker = () => {
  const dispatch = useDispatch();
  const vuln = useSelector(selectVulnDetail);
  const readOnly = useSelector(selectReadOnly);
  const permissions = useSelector(selectPermissions);
  const severity = get(vuln, 'severity', '');
  const value = {
    label: severity,
    value: severity
  };

  return (
    <Wrapper isDisabled={ readOnly || !permissions.update.allowed }>
      <Select
        styles={ severitySelect }
        isSearchable={ false }
        value={ value }
        isDisabled={ readOnly || !permissions.update.allowed }
        onChange={ (e) => dispatch(updateVulnGeneral(vuln, 'severity', e.value)) }
        options={ severities.map((element) => ({ label: <SeverityItem title={ element.name } />, value: element.name })) }
      />
    </Wrapper>
  );
};

export default SeverityPicker;
